import type { VendorDetail } from "@/lib/api/acquisitions";

type VendorTermsSectionProps = {
  vendor: VendorDetail;
};

export function VendorTermsSection({ vendor }: VendorTermsSectionProps) {
  const items = [
    { label: "Currency", value: vendor.currency || "—" },
    { label: "Tax rate", value: vendor.taxRate != null ? `${vendor.taxRate}%` : "—" },
    { label: "Discount", value: vendor.discountRate != null ? `${vendor.discountRate}%` : "—" },
    {
      label: "Avg. delivery",
      value: vendor.avgDeliveryDays != null ? `${vendor.avgDeliveryDays} days` : "—",
    },
  ];

  return (
    <section className="rounded-lg border border-slate-200 bg-white px-4 py-4 sm:px-5">
      <h2 className="text-sm font-semibold text-slate-900">Ordering terms</h2>
      <dl className="mt-3 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {items.map((item) => (
          <div key={item.label}>
            <dt className="text-xs text-slate-500">{item.label}</dt>
            <dd className="mt-0.5 text-sm font-medium text-slate-900">{item.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
